/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import cx from 'classnames';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import {
  PolymorphicComponentPropsWithRef,
  PolymorphicRef,
} from '../../Polymorphic';

interface ElementProps {
  className?: string | Array<string | string[]>;
  [key: string]: unknown;
}

interface InputElProps extends ElementProps {
  type?: string;
  placeholder?: string;
}

export interface InputProps {
  name: string;
  label: string;
  error?: string | null;
  inputProps?: InputElProps;
  labelProps?: ElementProps;
}

type InputComponentProps<C extends React.ElementType> =
  PolymorphicComponentPropsWithRef<C, InputProps>;

type InputComponent = <C extends React.ElementType = 'input'>(
  props: InputComponentProps<C>,
) => React.ReactElement | null;

export const Input: InputComponent = React.memo(
  React.forwardRef(
    <C extends React.ElementType = 'input'>(
      {
        as,
        name,
        label,
        inputProps,
        labelProps,
        error,
      }: InputComponentProps<C>,
      ref?: PolymorphicRef<C>,
    ) => {
      const Component = as || 'input';
      const { className: _inputClassName, ...restInputProps } =
        inputProps || {};
      const { className: labelClassName, ...restLabelProps } = labelProps || {};

      const inputClassName =
        typeof _inputClassName === 'string'
          ? _inputClassName
          : cx(_inputClassName);

      const inputErrorClassName = error ? ['border-red-500', 'border-2'] : [];

      return (
        <>
          <label
            htmlFor={name}
            className={twMerge(
              'block',
              'text-sm',
              'font-bold',
              'text-gray-700',
              'mb-1',
              labelClassName,
            )}
            {...restLabelProps}
          >
            {label}
          </label>
          <Component
            id={name}
            name={name}
            className={twMerge(
              'shadow-sm',
              'focus:ring-blue-400',
              'focus:border-blue-400',
              'block',
              'w-full',
              'sm:text-sm',
              'border-gray-400',
              'rounded',
              as === 'textarea' && ['max-h-[20vh]', 'min-h-[90px]'],
              ...inputErrorClassName,
              inputClassName,
            )}
            {...restInputProps}
            ref={ref}
          />
          {error && (
            <div className={cx(['text-red-500', 'text-xs', 'mt-2'])}>
              {error}
            </div>
          )}
        </>
      );
    },
  ),
);
